import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const INDEXING_ENABLED = true;

const SITE = {
  name: {
    en: "LANDKING KSA",
    ar: "???? ???? ????????"
  },
  alternateName: ["LANDKING Saudi Arabia", "BTATC LANDKING", "LANDKING"],
  domain: "https://www.landkingksa.com",
  ogImage: "https://www.landkingksa.com/og-image.jpg",
  logo: "https://www.landkingksa.com/logo192.png",
  twitterCard: "summary_large_image",
  email: "info@btatc.com",
  telephone: "8001240664",
  googleBusinessProfile: "https://share.google/NFUWo85ltwe5PpP5S",
  locales: {
    en: "en_SA",
    ar: "ar_SA"
  },
  address: {
    streetAddress: "7358 Eastern Ring Branch Rd, Al Faisaliyyah",
    addressLocality: "Riyadh",
    postalCode: "12896",
    addressCountry: "SA"
  }
};

const SEO_MAP = {
  "/": {
    en: {
      title: "LANDKING KSA | Light Commercial Vehicles in Saudi Arabia",
      description:
        "Official LANDKING distributor in Saudi Arabia for light commercial vehicles, delivery trucks, cargo transport, fleet operations, genuine parts and aftersales support.",
      keywords:
        "LANDKING KSA, LANDKING Saudi Arabia, LANDKING trucks, light commercial vehicles Saudi Arabia, commercial trucks Saudi Arabia, delivery trucks Saudi Arabia, cargo trucks Saudi Arabia, fleet vehicles Saudi Arabia"
    },
    ar: {
      title: "???? ???? ???????? | ???????? ???????? ??????? ?? ????????",
      description:
        "?????? ?????? ??????? ???? ???? ?? ??????? ??????? ????????. ?????? ?????? ????? ?????? ???????? ??? ??????? ?????? ????????? ?? ??? ???? ????? ???? ?? ??? ?????.",
      keywords:
        "???? ???? ????????, LANDKING ????????, ?????? ?????? ?????, ?????? ?????? ????????, ?????? ?????, ?????? ???, ????? ?????, BTATC"
    }
  },
  "/vehicles": {
    en: {
      title: "LANDKING Vehicles | Commercial Trucks in Saudi Arabia",
      description:
        "Explore LANDKING light commercial vehicles in Saudi Arabia, built for cargo delivery, fleet transport, business logistics and daily commercial operations.",
      keywords:
        "LANDKING vehicles Saudi Arabia, commercial trucks Saudi Arabia, light duty trucks Saudi Arabia, fleet trucks KSA, cargo vehicles Saudi Arabia, delivery vehicles Saudi Arabia"
    },
    ar: {
      title: "?????? ???? ???? | ?????? ?????? ?? ????????",
      description:
        "?????? ?????? ???? ???? ???????? ??????? ?? ??????? ??????? ????????? ??????? ???????? ??? ???????? ???????? ??????? ??????? ???????.",
      keywords:
        "?????? ???? ????, ?????? ?????? ????????, ?????? ????? ????????, ?????? ???, ?????? ?????, ????? ?????"
    }
  },
  "/vehicles/h-series": {
    en: {
      title: "LANDKING H-Series | Light Duty Truck Saudi Arabia",
      description:
        "Discover the LANDKING H-Series light duty truck in Saudi Arabia, designed for delivery, cargo movement, fleet operations and reliable business transport.",
      keywords:
        "LANDKING H-Series Saudi Arabia, H-Series light duty truck, LANDKING truck Saudi Arabia, delivery truck Saudi Arabia, cargo truck KSA, light commercial truck Saudi Arabia"
    },
    ar: {
      title: "???? ???? H-Series | ????? ????? ?? ????????",
      description:
        "????? ?????? ???? ???? H-Series ?? ??????? ??????? ????????? ??????? ???????? ??? ???????? ????? ???????? ?????? ??????? ??????.",
      keywords:
        "???? ???? H-Series, ????? ???? ????, ????? ????? ????????, ????? ?????, ????? ?????, ????? ?????? ?????"
    }
  },
  "/spare-parts": {
    en: {
      title: "LANDKING Spare Parts | Genuine Truck Parts Saudi Arabia",
      description:
        "Get genuine LANDKING spare parts in Saudi Arabia for light commercial vehicles, with reliable parts support for fleets, cargo trucks and delivery operations.",
      keywords:
        "LANDKING spare parts Saudi Arabia, genuine truck parts KSA, commercial vehicle spare parts Saudi Arabia, LANDKING parts Riyadh, truck spare parts Saudi Arabia"
    },
    ar: {
      title: "??? ???? ???? ???? | ??? ?????? ????? ?? ????????",
      description:
        "???? ??? ??? ???? ???? ???? ??????? ?? ??????? ??????? ???????? ???????? ???????? ???????? ?? ??? ????? ???????? ??????? ??????? ????????.",
      keywords:
        "??? ???? ???? ????, ??? ?????? ?????, ??? ???? ?????? ??????, ??? ???? ?????? ????????, ???? ???? ??????"
    }
  },
  "/offers": {
    en: {
      title: "LANDKING Offers | Commercial Vehicle Deals Saudi Arabia",
      description:
        "View LANDKING KSA offers for light commercial vehicles, showroom test drives, fleet support and business vehicle deals in Saudi Arabia.",
      keywords:
        "LANDKING offers Saudi Arabia, truck offers Saudi Arabia, commercial vehicle deals KSA, LANDKING H-Series offers, fleet vehicle offers"
    },
    ar: {
      title: "???? ???? ???? | ???? ???????? ???????? ?? ????????",
      description:
        "???? ??? ???? ???? ???? ???????? ???????? ???????? ???????? ????? ???????? ??? ???????? ????? ?????? ??????? ?? ???????.",
      keywords:
        "???? ???? ????, ???? ?????? ????????, ???? ?????? ??????, ???? H-Series, ???? ??????"
    }
  },
  "/services": {
    en: {
      title: "LANDKING Service | Truck Maintenance Saudi Arabia",
      description:
        "Professional LANDKING aftersales service in Saudi Arabia, including commercial truck maintenance, repair support, warranty assistance and fleet care.",
      keywords:
        "LANDKING service Saudi Arabia, truck maintenance Saudi Arabia, commercial vehicle service KSA, aftersales support Saudi Arabia, LANDKING warranty support"
    },
    ar: {
      title: "????? ???? ???? | ????? ???????? ?? ????????",
      description:
        "????? ?? ??? ????? ??????? ???? ???? ?? ??????? ??????? ????????? ???? ????? ???????? ????????? ?????????? ??? ?????? ????? ????????.",
      keywords:
        "????? ???? ????, ????? ?????? ????????, ????? ?????? ??????, ???? ?? ??? ?????, ???? ???? ????"
    }
  },
  "/about-us": {
    en: {
      title: "About LANDKING KSA | Official Distributor in Saudi Arabia",
      description:
        "Learn about LANDKING KSA and BTATC, the official LANDKING distributor in Saudi Arabia for light commercial vehicles, spare parts and aftersales support.",
      keywords:
        "LANDKING KSA, LANDKING Saudi Arabia, official LANDKING distributor Saudi Arabia, BTATC LANDKING, LANDKING dealer KSA"
    },
    ar: {
      title: "?? ???? ???? ???????? | ?????? ?????? ?? ????????",
      description:
        "???? ??? ???? ???? ???????? ?BTATC? ?????? ?????? ??????? ???? ???? ?? ??????? ??????? ???????? ???????? ???????? ??????? ???? ?????? ????????.",
      keywords:
        "?? ???? ????, ???? ???? ????????, ?????? ?????? ???? ????, ???? ???? ????, BTATC"
    }
  },
  "/locations": {
    en: {
      title: "LANDKING Showroom Riyadh | Locations in Saudi Arabia",
      description:
        "Find LANDKING showroom and service locations in Saudi Arabia for commercial vehicle sales, spare parts, maintenance and customer support.",
      keywords:
        "LANDKING showroom Riyadh, LANDKING location Saudi Arabia, commercial truck dealer Riyadh, LANDKING service center KSA, truck showroom Saudi Arabia"
    },
    ar: {
      title: "???? ???? ???? ?????? | ????? ???? ???? ?? ????????",
      description:
        "???? ??? ????? ?????? ???? ???? ???? ?? ??????? ??????? ???????? ??????? ???????? ???????? ???? ?????? ???????? ???? ???????.",
      keywords:
        "???? ???? ???? ??????, ????? ???? ???? ????????, ???? ???? ???? ????, ???? ?????? ??????, ???? ?????? ????????"
    }
  },
  "/news": {
    en: {
      title: "LANDKING News | Commercial Vehicle Updates Saudi Arabia",
      description:
        "Read the latest LANDKING KSA news, showroom updates, vehicle launches, commercial truck insights and BTATC announcements in Saudi Arabia.",
      keywords:
        "LANDKING news Saudi Arabia, LANDKING KSA updates, commercial vehicle news Saudi Arabia, BTATC news, truck launch Saudi Arabia"
    },
    ar: {
      title: "????? ???? ???? | ??????? ???????? ???????? ?? ????????",
      description:
        "???? ???? ????? ???? ???? ????????? ??????? ???????? ????? ????????? ????? ???????? ???????? ???????? BTATC ?? ??????? ??????? ????????.",
      keywords:
        "????? ???? ????, ????? ???????? ????????, ??????? ???? ????, ????? BTATC, ????? ?????? ????????"
    }
  },
  "/news/landking-showroom-riyadh-opening-btatc": {
    en: {
      title: "LANDKING Showroom Opens in Riyadh | BTATC Saudi Arabia",
      description:
        "BTATC launches the LANDKING showroom in Riyadh, introducing H-Series and EH electric trucks for Saudi Arabia's commercial vehicle market.",
      keywords:
        "LANDKING showroom Riyadh, BTATC LANDKING Saudi Arabia, LANDKING H-Series launch, LANDKING electric trucks Saudi Arabia, commercial vehicle showroom Riyadh",
      article: {
        headline:
          "LANDKING Showroom Opens in Riyadh: BTATC Launches H-Series and EH Electric Trucks in Saudi Arabia",
        datePublished: "2025-12-10",
        dateModified: "2025-12-10",
        authorName: "BTATC"
      }
    },
    ar: {
      title: "?????? ???? ???? ???? ?? ?????? | BTATC ????????",
      description:
        "???? BTATC ???? ???? ???? ?? ??????? ?? ????? ?????? H-Series ??????? EH ?????????? ???? ???????? ???????? ?? ????????.",
      keywords:
        "?????? ???? ???? ???? ??????, BTATC ???? ???? ????????, ?????? H-Series, ?????? ???????? ????????, ???? ?????? ?????? ??????",
      article: {
        headline:
          "?????? ???? ???? ???? ?? ??????: BTATC ???? ?????? H-Series ?EH ?????????? ?? ????????",
        datePublished: "2025-12-10",
        dateModified: "2025-12-10",
        authorName: "BTATC"
      }
    }
  },
  "/faq": {
    en: {
      title: "LANDKING FAQ | Trucks, Parts and Service Saudi Arabia",
      description:
        "Find answers about LANDKING light commercial vehicles in Saudi Arabia, including truck models, warranty, spare parts, service and aftersales support.",
      keywords:
        "LANDKING FAQ Saudi Arabia, LANDKING warranty KSA, LANDKING spare parts, LANDKING truck service, LANDKING commercial vehicles"
    },
    ar: {
      title: "??????? ??????? | ?????? ???? ?????? ???? ????",
      description:
        "???? ??? ?????? ??? ?????? ???? ???? ???????? ??????? ?? ????????? ??? ???? ?????????? ??????? ??? ??????? ??????? ?????? ?? ??? ?????.",
      keywords:
        "??????? ??????? ???? ????, ???? ???? ????, ??? ???? ???? ????, ???? ???? ????, ?????? ???? ????"
    }
  },
  "/privacy-policy": {
    en: {
      title: "Privacy Policy | LANDKING KSA",
      description:
        "Read the LANDKING KSA privacy policy and learn how visitor and customer information is collected, used and protected.",
      keywords: "LANDKING KSA privacy policy, LANDKING Saudi Arabia privacy"
    },
    ar: {
      title: "????? ???????? | ???? ???? ????????",
      description:
        "???? ????? ???????? ?????? ????? ???? ???????? ????? ??? ????? ??? ??????? ?????? ???????? ?????????? ????????.",
      keywords: "????? ???????? ???? ????, ?????? ???? ???? ????????"
    }
  },
  "/terms-conditions": {
    en: {
      title: "Terms and Conditions | LANDKING KSA",
      description:
        "Read the terms and conditions for using the LANDKING KSA website, services, vehicle information and customer support pages.",
      keywords: "LANDKING KSA terms and conditions, LANDKING Saudi Arabia terms"
    },
    ar: {
      title: "?????? ???????? | ???? ???? ????????",
      description:
        "???? ?????? ???????? ?????? ???????? ???? ???? ???? ???????? ???????? ???????? ???????? ?????? ??? ???????.",
      keywords: "?????? ???????? ???? ????, ???? ???? ???? ????????"
    }
  }
};

const H_SERIES_OFFER = {
  price: "79800.00",
  priceCurrency: "SAR",
  availability: "https://schema.org/InStock",
  itemCondition: "https://schema.org/NewCondition"
};

function normalizeLang(rawLang) {
  if (!rawLang) return "en";
  return rawLang.toLowerCase().startsWith("ar") ? "ar" : "en";
}

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

function getRouteData(path) {
  if (SEO_MAP[path]) return SEO_MAP[path];
  if (path.startsWith("/news/")) return SEO_MAP["/news"];
  if (path.startsWith("/vehicles/")) return SEO_MAP["/vehicles"];
  return SEO_MAP["/"];
}

function getLocalizedData(routeData, lang) {
  return routeData[lang] || routeData.en || SEO_MAP["/"].en;
}

function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  let selector = `link[rel="${rel}"]`;
  if (hreflang) selector += `[hreflang="${hreflang}"]`;

  let link = document.querySelector(selector);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    if (hreflang) link.setAttribute("hreflang", hreflang);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let tag = document.querySelector(`script[data-schema-id="${id}"]`);
  if (!tag) {
    tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.setAttribute("data-schema-id", id);
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
}

function removeJsonLd(id) {
  document.querySelectorAll(`script[data-schema-id="${id}"], #${id}`).forEach((tag) => tag.remove());
}

function buildBreadcrumbSchema(path, data, lang) {
  const homeName = lang === "ar" ? "????????" : "Home";
  const items = [
    {
      "@type": "ListItem",
      position: 1,
      name: homeName,
      item: `${SITE.domain}/`
    }
  ];

  if (path !== "/") {
    const segments = path.split("/").filter(Boolean);
    let currentPath = "";

    segments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const routeData = getRouteData(currentPath);
      const localizedData = getLocalizedData(routeData, lang);
      const name = localizedData.title.split("|")[0].trim() || data.title;

      items.push({
        "@type": "ListItem",
        position: index + 2,
        name,
        item: `${SITE.domain}${currentPath}`
      });
    });
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items
  };
}

export default function MetaManager() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n?.resolvedLanguage || i18n?.language || document.documentElement.lang);

  useEffect(() => {
    const path = normalizePath(pathname);
    const routeData = getRouteData(path);
    const data = getLocalizedData(routeData, lang);
    const canonical = SITE.domain + (path === "/" ? "/" : path);
    const siteName = SITE.name[lang] || SITE.name.en;
    const locale = SITE.locales[lang] || SITE.locales.en;
    const isHSeriesPage = path === "/vehicles/h-series";
    const isNewsArticle = path === "/news/landking-showroom-riyadh-opening-btatc";
    const socialImage = SITE.ogImage;

    document.documentElement.lang = lang === "ar" ? "ar-SA" : "en-SA";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = data.title;

    upsertMeta("description", data.description);
    upsertMeta("keywords", data.keywords);
    upsertMeta("robots", INDEXING_ENABLED ? "index, follow" : "noindex, follow");
    upsertMeta("language", lang === "ar" ? "Arabic" : "English");
    upsertLink("canonical", canonical);

    upsertProperty("og:type", isNewsArticle ? "article" : "website");
    upsertProperty("og:site_name", siteName);
    upsertProperty("og:locale", locale);
    upsertProperty("og:url", canonical);
    upsertProperty("og:title", data.title);
    upsertProperty("og:description", data.description);
    upsertProperty("og:image", socialImage);

    upsertMeta("twitter:card", SITE.twitterCard);
    upsertMeta("twitter:title", data.title);
    upsertMeta("twitter:description", data.description);
    upsertMeta("twitter:image", socialImage);

    upsertLink("alternate", canonical, "en-SA");
    upsertLink("alternate", canonical, "ar-SA");
    upsertLink("alternate", canonical, "x-default");

    upsertJsonLd("website-schema", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${SITE.domain}/#website`,
      url: `${SITE.domain}/`,
      name: siteName,
      alternateName: SITE.alternateName,
      inLanguage: lang === "ar" ? "ar-SA" : "en-SA",
      publisher: {
        "@id": `${SITE.domain}/#organization`
      }
    });

    upsertJsonLd("organization-schema", {
      "@context": "https://schema.org",
      "@type": "AutoDealer",
      "@id": `${SITE.domain}/#organization`,
      name: siteName,
      alternateName: SITE.alternateName,
      url: `${SITE.domain}/`,
      logo: SITE.logo,
      image: SITE.ogImage,
      description:
        lang === "ar"
          ? "?????? ?????? ??????? ???? ???? ?? ??????? ??????? ????????? ????? ???????? ???????? ??????? ???? ?????? ??????? ?????? ?? ??? ?????."
          : "Official LANDKING distributor in Saudi Arabia, offering light commercial vehicles, genuine spare parts and professional aftersales support.",
      telephone: SITE.telephone,
      email: SITE.email,
      address: {
        "@type": "PostalAddress",
        streetAddress: SITE.address.streetAddress,
        addressLocality: SITE.address.addressLocality,
        postalCode: SITE.address.postalCode,
        addressCountry: SITE.address.addressCountry
      },
      areaServed: {
        "@type": "Country",
        name: "Saudi Arabia"
      },
      hasMap: SITE.googleBusinessProfile,
      sameAs: [
        "https://www.instagram.com/landking.ksa/",
        "https://www.facebook.com/landking.ksa",
        "https://x.com/LandkingKsa",
        "https://www.linkedin.com/in/landking-ksa/",
        SITE.googleBusinessProfile
      ]
    });

    upsertJsonLd("breadcrumb-schema", buildBreadcrumbSchema(path, data, lang));

    if (isHSeriesPage) {
      upsertJsonLd("product-h-series", {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": `${SITE.domain}/vehicles/h-series#product`,
        name: lang === "ar" ? "???? ???? H-Series" : "LANDKING H-Series",
        alternateName: ["LANDKING H Series", "LANDKING H-Series Light Duty Truck"],
        image: [SITE.ogImage],
        description: data.description,
        brand: {
          "@type": "Brand",
          name: "LANDKING"
        },
        manufacturer: {
          "@type": "Organization",
          name: "LANDKING"
        },
        category: lang === "ar" ? "????? ?????? ?????" : "Light commercial vehicle",
        sku: "LANDKING-H-SERIES",
        model: "H-Series",
        url: canonical,
        inLanguage: lang === "ar" ? "ar-SA" : "en-SA",
        areaServed: {
          "@type": "Country",
          name: "Saudi Arabia"
        },
        offers: {
          "@type": "Offer",
          url: canonical,
          price: H_SERIES_OFFER.price,
          priceCurrency: H_SERIES_OFFER.priceCurrency,
          availability: H_SERIES_OFFER.availability,
          itemCondition: H_SERIES_OFFER.itemCondition,
          seller: {
            "@id": `${SITE.domain}/#organization`,
            name: siteName
          }
        }
      });
    } else {
      removeJsonLd("product-h-series");
      removeJsonLd("product-schema");
    }

    if (isNewsArticle && data.article) {
      upsertJsonLd("article-landking-riyadh-opening", {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "@id": `${canonical}#article`,
        headline: data.article.headline,
        description: data.description,
        image: [socialImage],
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": canonical
        },
        url: canonical,
        inLanguage: lang === "ar" ? "ar-SA" : "en-SA",
        datePublished: data.article.datePublished,
        dateModified: data.article.dateModified,
        author: {
          "@type": "Organization",
          name: data.article.authorName
        },
        publisher: {
          "@id": `${SITE.domain}/#organization`,
          name: siteName,
          logo: {
            "@type": "ImageObject",
            url: SITE.logo
          }
        }
      });
    } else {
      removeJsonLd("article-landking-riyadh-opening");
      removeJsonLd("article-schema");
    }
  }, [pathname, lang]);

  return null;
}
